import { Stack } from '@mui/material'
import LamenessChart from 'components/cattles/lamenessPage/shared/LamenessChart'
import { getDatesArray } from 'components/shared/processes'
import useLamenessInfoForChart from 'hook/query/useLamenessInfoForChart'
import { LamenessTypeChart } from 'models'
import { LicensesType } from 'models/IUserData'
import moment from 'moment'
import { useCallback, useState } from 'react'
import { useAppSelector } from 'store/hooks'

import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'
import ExpandableCard from 'ui/expandable-card/ExpandableCard'
import Preloader from 'ui/Preloader'
import { ExpiredLicense } from '../../../ui/expired-license/ExpiredLicense'
interface ILamenessCard {
	groupId: number
}
export const LamenessCard = (props: ILamenessCard) => {
	const { groupId } = props
	const weekDays = getDatesArray(6)
	const [dateRange, setDateRange] = useState({
		startDate: weekDays.startDate,
		endDate: weekDays.endDate,
	})
	const onChangeCallback = useCallback(value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}, [])
	const { dotsInfo, isLoading, error } = useLamenessInfoForChart(
		dateRange,
		groupId,
	)
	const { userData } = useAppSelector(state => state.userReducer)
	const licenseInfo = userData?.company?.licenses?.find(
		el => el.license_codename === LicensesType.LAMENESS,
	)
	return (
		<ExpandableCard title={'Хромота'} hideToggle>
			<Stack direction={'column'} gap={'24px'} minHeight={'300px'} mt={'24px'}>
				<DateRangePicker
					onChangeUpdateDate={onChangeCallback}
					weekFilter={true}
					monthFilter={true}
					yearFilter={true}
					currentRange={'Неделя'}
					startDate={dateRange.startDate}
					endDate={dateRange.endDate}
				/>
				{isLoading ? (
					<Preloader mt={6} />
				) : error?.response?.status === 450 ? (
					<ExpiredLicense
						mt={'80px'}
						availableLicenceDates={`Доступен просмотр данных за период ${moment(
							licenseInfo.start_dt,
						).format('DD.MM.YY')} - ${moment(licenseInfo.until_dt).format(
							'DD.MM.YY',
						)}`}
					/>
				) : (
					<LamenessChart
						dotsInfo={dotsInfo}
						selectTypeOfChart={LamenessTypeChart.PointType}
					/>
				)}
			</Stack>
		</ExpandableCard>
	)
}
